import { useNavigate } from 'react-router-dom';

import InviteFriendsPage, {
  CompetitionType,
} from '../inviteFriends/InviteFriendsPage';

import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import {
  inviteToTournament,
  inviteUserById,
  suggestUsersToInvite,
  searchDtsByName,
} from '@/services/invites';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

function TournamentInvitePage() {
  const { handleSetTourney, tourneyData } = useTourney();

  const navigate = useNavigate();

  const tournamentServices = {
    inviteByEmail: inviteToTournament,
    inviteById: inviteUserById,
    suggestUsers: suggestUsersToInvite,
    searchByName: searchDtsByName,
  };

  const handleNavigateToTourney = () => {
    handleSetTourney({
      ...tourneyData,
      id: tourneyData.id,
    });

    navigate(ROUTES.viewTourney);
  };

  return (
    <InviteFriendsPage
      adsSections={SECTION_NAME_FOR_ADS.torneodeamigos}
      competitionId={tourneyData.id}
      redirectRoute={handleNavigateToTourney}
      services={tournamentServices}
      type={CompetitionType.TOURNAMENT}
    />
  );
}

export default TournamentInvitePage;
